var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"button",class:{expanded: _vm.active}},_vm.$listeners),[_c('span',{staticClass:"triangle"},[_vm._v("▸")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }